import React from 'react'
import { Route } from 'react-router-dom'
import FlowHandler from '../shared/FlowHandler/'
import Header from '../shared/header'
import Footer from '../shared/footer'
import Quando from '../quando'
import Dove from '../dove'
import DataAppuntamento from '../data_appuntamento'
import Filiale from '../filiale'
import CodiceFiscale from '../codice_fiscale'
import DatiPersonali from '../dati_personali'
import DatiPersonaliContactCenter from '../dati_contact_center'
import Riepilogo from '../riepilogo'
import RiepilogoCLink from '../thank_you_page_clink'
import ThankYouPageCq from '../thank_you_page_cq'
import ThankYouPageAUP from '../thank_you_page_AUP'
import RiepilogoModificaAppuntamento from '../riepilogo_modifica_appuntamento';
import ConfermaModificaAppuntamento from '../conferma_modifica_appuntamento';
import PrivacyConsensi from '../privacy_consensi';
import utils from '../../modules/utils.js'
import history from '../../modules/history'
/* CSS */
import './main.css';
/* Flow */
import { handleFlow } from '../../flow/flow';

class App extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    localStorage.removeItem("qs");
    handleFlow();
    
    if (typeof window.mapkit != "undefined") {
      this.initMap();
    } else {
      if (window.location.hostname != "localhost") {
        let tentativi_inizializzazione_mappa_max = 50;
        let init_interval = window.setInterval(function () {
          let initialized = false;
          if (typeof window.mapkit != "undefined") {
            this.initMap();
          }
          tentativi_inizializzazione_mappa_max--;
          if (initialized || tentativi_inizializzazione_mappa_max < 1) {
            clearInterval(init_interval);
          }
        }, 500);
      }
    }
    history.listen((location) => {
      if (
        history.action === 'POP'
        && window.location.host.indexOf('quinto') != -1
        && window.location.pathname == '/fissa-appuntamento'
      ) { //In caso di back da compassquinto riverifichiamo il flusso
        handleFlow();
      }
      window.scrollTo(0, 0);
    });
    
    utils.scrollToTop();
  }

  initMap() {
    window.mapkit.init({
      authorizationCallback: function (done) {
        fetch("https://api.appcenter.it/mapkit")
          .then(function (res) {
            var token_promise = res.text()
            token_promise.then(function (token) {
              done(token)
            })
          })
      }
    });
  }

  render() {
    return (
      <div>
        <Header />
        <FlowHandler />

        <main>
          <Route exact path="/fissa-appuntamento" component={Quando} />
          <Route exact path="/fissa-appuntamento/scegli-dove" component={Dove} />
          <Route exact path="/fissa-appuntamento/scegli-luogo" component={Dove} />
          <Route exact path="/fissa-appuntamento/data-appuntamento" component={DataAppuntamento} />
          <Route exact path="/fissa-appuntamento/scelta-filiale" component={Filiale} />
          <Route exact path="/fissa-appuntamento/dati-personali" component={DatiPersonali} />
          <Route exact path="/fissa-appuntamento/dati-personali-riconosciuto" component={DatiPersonali} />
          <Route exact path="/fissa-appuntamento/clink" component={DatiPersonali} />
          <Route exact path="/fissa-appuntamento/dati-personali-richiamami" component={DatiPersonaliContactCenter} />
          <Route exact path="/fissa-appuntamento/codice-fiscale" component={CodiceFiscale} />
          <Route exact path="/fissa-appuntamento/thank-you-page" component={Riepilogo} />
          <Route exact path="/fissa-appuntamento/thank-you-page-CQ" component={ThankYouPageCq} />
          <Route exact path="/fissa-appuntamento/typ_RICHIAMAMI" component={ThankYouPageCq} />
          <Route exact path="/fissa-appuntamento/thank-you-page-clink" component={RiepilogoCLink} />
          <Route exact path="/fissa-appuntamento/thank-you-page-clink-CC" component={RiepilogoCLink} />
          <Route exact path="/fissa-appuntamento/thank-you-page-AUP" component={ThankYouPageAUP} />
          <Route exact path="/fissa-appuntamento/riepilogo-modifica-appuntamento" component={RiepilogoModificaAppuntamento} />
          <Route exact path="/fissa-appuntamento/conferma-modifica-appuntamento" component={ConfermaModificaAppuntamento} />
          <Route exact path="/fissa-appuntamento/privacy-e-consensi" component={PrivacyConsensi} />
        </main>

        <Footer />
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/app/index.js